import React from 'react';
import ReactDOM from 'react-dom';

export default class Scroller extends React.Component {
  constructor(props) {
    super(props);
    this.scroll = null;
  }

  componentDidMount() {
    /* eslint-disable react/no-find-dom-node */

    this.scroll = ReactDOM.findDOMNode(this.self).querySelector('.main__body');
    /* eslint-enable react/no-find-dom-node */
    this.scroll.style.height = `${window.innerHeight -
      this.scroll.getBoundingClientRect().top}px`;
  }

  render() {
    return (
      <div
        ref={e => {
          this.self = e;
        }}
      >
        {this.props.children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Scroller.jsx